export const LOAD_STATE = 'event-widgets/state/LOAD_STATE';

// Note: Blank option is added after getting the response from the service
const blankStateData = {
  id: 0,
  code: '',
  categoryId: 0,
  nameResourceKey: '',
  name: '',
  categoryName: '',
  categoryNameResourceKey: '',
  categoryOrder: 0,
  countryCode: ''
};

/*
 * Creates a thunked action to load the state list based on the selected country from the lookup.
 */
export function loadState(registerTranslation, countryCode) {
  return async (dispatch, getState) => {
    const { accessToken, text: { locale, translate }, states: loadedCountryStates,
      clients: { lookupClient } } = getState();
    let states = {};
    if (countryCode) {
      if (loadedCountryStates && loadedCountryStates[countryCode] &&
        loadedCountryStates[countryCode].locale === locale) {
        return;
      }
      try {
        const statesLookupResponse = await lookupClient.getStates(accessToken, countryCode, locale);
        const translations = statesLookupResponse.translations;
        for (const translationLocale in translations) {
          if (translations.hasOwnProperty(translationLocale)) {
            dispatch(registerTranslation(translations[translationLocale], translationLocale));
          }
        }
        const statesResponse = statesLookupResponse.states;
        // Inserting blank entry to state list and sorting it by name
        states[''] = blankStateData;
        Object.keys(statesResponse).sort((a, b) => {
          return translate(statesResponse[a].nameResourceKey).localeCompare(
            translate(statesResponse[b].nameResourceKey));
        }).forEach(code => {
          states[code] = statesResponse[code];
        });
      } catch (err) {
        // 400 Bad Request indicates that the country does not have state data to use, so this error should be ignored
        if (err.responseStatus !== 400) {
          throw err;
        }
      }
    }
    const countryStates = {
      [countryCode]: {
        states,
        locale
      }
    };
    dispatch({ type: LOAD_STATE, payload: { countryStates } });
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case LOAD_STATE: {
      const newState = Object.assign({}, state, action.payload.countryStates);
      return { ...newState };
    }
    default:
      return state;
  }
}
